import { render, staticRenderFns } from "./ChatGameRole.vue?vue&type=template&id=e7d43c20&"
import script from "./ChatGameRole.vue?vue&type=script&lang=js&"
export * from "./ChatGameRole.vue?vue&type=script&lang=js&"
import style0 from "./ChatGameRole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports